import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Estado de Cuenta del Cliente
 *
 * Reporte:
 * Cuentas por Cobrar (CxC)
 *
 * Filtros requeridos:
 * - Cliente
 * - Fecha Desde
 * - Fecha Hasta
 *
 * Backend esperado:
 *
 * customerId
 * dateFrom
 * dateTo
 */
export const estadoCuentaClienteReportFilters: UniversalFilterConfig[] = [
    {
        name: "customerId",
        label: "Cliente",
        type: "select",
        iconKey: "user",
    },
    {
        name: "dateFrom",
        label: "Fecha Desde",
        type: "date",
        iconKey: "calendar",
    },
    {
        name: "dateTo",
        label: "Fecha Hasta",
        type: "date",
        iconKey: "calendar",
    },
];